import { useCallback } from "react";
import { getCurrentPlant } from "../../util/ApiOptionsHelper";
import { getColumnsWithGroup } from "../../api/Windows";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetMeterMetadata() {
  const setMetadata = useWorkOrderStore((state) => state.setWoMeterMetadata);
  const setWoMeterHistoryMetadata = useWorkOrderStore(
    (state) => state.setWoMeterHistoryMetadata
  );
  const setNewMeterMetadata = useWorkOrderStore(
    (state) => state.setNewMeterMetadata
  );

  const getMeterMetadata = useCallback(
    async (isHistory?: boolean, isNew?: boolean) => {
      let windowName = "mob_meter";
      if (isHistory) windowName = "mob_meter_history";
      if (isNew) windowName = "mob_meter_new";
      const data = {
        IncludeValidValues: false,
        IncludeValidValuesExceptions: [],
        IsReadOnly: true,
        ValidValueFilters: [],
        WindowName: windowName,
        ContextPKey: {
          Plant: await getCurrentPlant(),
          WoBase: "",
          WoTask: "  ",
          WoSubtask: "  ",
        },
      };
      const response = await getColumnsWithGroup(data);
      if (!response.isError) {
        if (isHistory) {
          delete response.data.fields["eq_readings_history.reading_time"];
          setWoMeterHistoryMetadata(response.data);
        } else if (isNew) setNewMeterMetadata(response.data);
        else setMetadata(response.data);
      }
      return response;
    },
    [setMetadata, setNewMeterMetadata, setWoMeterHistoryMetadata]
  );

  return { getMeterMetadata };
}
